<script>
import { memberListAgentadminMethods } from '@/src/state/helpers/member-list-agentadmin'
import formatDate from '@/src/utils/format-date'
import cloneDeep from 'lodash/cloneDeep'
import chartDateListRangeType from '@utils/chartDateListRangeType'
import { TIME_SELECT } from '@utils/constant'
import configChart from './configChart'

export default {
  data() {
    return {
      configChart: configChart,
      endDate: null,
      nowDate: null,
      range: '1',
      TIME_SELECT: TIME_SELECT,
    }
  },
  created() {
    this.nowDate = formatDate(new Date())
    this.handledfetchChart()
  },
  methods: {
    ...memberListAgentadminMethods,
    async handledfetchChart() {
      const response = await this.fetchingChartData({
        range_type: parseInt(this.range),
        end_date: this.nowDate,
      })
      if (response) {
        this.chartData = response.data
        this.startDate = response.data_start
        this.endDate = response.data_end
        this.handleGetChartData()
      }
    },
    handleGetChartData() {
      this.configChart.data.labels = chartDateListRangeType(
        parseInt(this.range),
        this.startDate,
        this.endDate
      )
      const data = cloneDeep(this.chartData)?.map((v) => {
        return {
          x: v.label,
          y: v.value,
        }
      })

      this.configChart.data.datasets[0].data = data

      this.configChart.options.scales.xAxes[0].time.unit = 'day'
      this.configChart.options.scales.xAxes[0].ticks.source = 'labels'
      if (this.range === this.TIME_SELECT.week) {
        this.configChart.options.scales.xAxes[0].ticks.source = 'labels'
      } else if (this.range === this.TIME_SELECT.month) {
        this.configChart.options.scales.xAxes[0].ticks.source = 'labels'
        this.configChart.options.scales.xAxes[0].time.unit = 'month'
      }
    },
    switchType(type) {
      this.range = type
      this.handledfetchChart()
    },
    fetchChart(date) {
      this.nowDate = date
      this.handledfetchChart()
    },
  },
}
</script>

<template>
  <div>
    <div class="d-flex justify-content-end">
      <CButtonGroup>
        <CButton
          :class="{ active: range === TIME_SELECT.day }"
          color="dark"
          variant="outline"
          @click="switchType(TIME_SELECT.day)"
          >日</CButton
        >
        <CButton
          :class="{ active: range === TIME_SELECT.week }"
          color="dark"
          variant="outline"
          @click="switchType(TIME_SELECT.week)"
          >週</CButton
        >
        <CButton
          :class="{ active: range === TIME_SELECT.month }"
          color="dark"
          variant="outline"
          @click="switchType(TIME_SELECT.month)"
          >月</CButton
        >
      </CButtonGroup>
    </div>
    <div>
      <CChartLine
        style="height:400px"
        :labels="configChart.data.labels"
        :datasets="configChart.data.datasets"
        :options="configChart.options"
      />
    </div>
    <BaseSwitchTimeChart
      class="mx-5"
      :end-date="endDate"
      :range="range"
      @getDate="fetchChart"
    />
  </div>
</template>
